export function mapStoreTradingHourDayToTradingSchedule(tradingHours) {
  return {
    isStoreCentreLinked: true,
    tradingHours
  };
}